// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"896d869a","124":"4fbd93c7","239":"5609229f","264":"efa5fbd6","325":"01077a33","429":"c6ac1cf4","453":"f192ab00","480":"a9964fe2","638":"538cd23e"}[chunkId] + ".chunk.js";
};